module.exports = __webpack_public_path__ + "img/MSME UDAYAM.04bcf538.png";